
  export default {
    data() {
      return {
  
        form : {
                  id : '',
                  level : '',
                  keterangan : '',
                  file : null,
                  tahun : '',
                  createAt : '',
                  editedAt : '',
                  file_old : null
              },
  
        tahun : '',
        unit : '',
        unitKerja : '',
        unit_lppd : '',
        url_output : '',
       
        list_data : [],
        list_tahun : [],
        list_unit : [],
        file_path: this.$store.state.url.URL_APP + "uploads/",
  
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,
  
        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        btn_add: false,
        mdl_open: false,
  
      }
    },
    methods: {
  
      getView : function(){
        this.$store.commit("shoWLoading");
        console.log(this.url_output);
        fetch(this.$store.state.url.URL_INSPEKTORAT + "viewApip", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                tahun : this.tahun,
                unit : this.unit,
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.$store.commit("hideLoading");
                console.log(res_data);
        });
      },
  
      getUnit : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Unit+"view", {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data);
                this.list_unit = res_data;
                this.$store.commit("hideLoading");
        });
      },
  
      getTahun : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Tahun, {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data);
                this.list_tahun = res_data;
                this.$store.commit("hideLoading");
        });
      },
  
      addData : function() {
        console.log(this.form);
        var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))
        formData.append('file', this.form.file)
        fetch(this.$store.state.url.URL_INSPEKTORAT + "addApip", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'indigo-10', 'check_circle_outline');
            console.log(res_data);
            this.getView();
        });
      },
  
  
      editData : function(){
        var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))
        formData.append('file', this.form.file)
        fetch(this.$store.state.url.URL_INSPEKTORAT + "editApip", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'lime-7', 'check_circle_outline');
            this.getView();
        });
      },
  
      removeData : function(a, b){
        fetch(this.$store.state.url.URL_INSPEKTORAT + "removeApip", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : a, file : b})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'deep-orange-10', 'check_circle_outline');
            this.getView();
        });
  
      },
  
      selectData : function(data){
        console.log(data);
          this.form.id = data.id
          this.form.level = data.level
          this.form.keterangan = data.keterangan
          this.form.file = this.form.file
          // this.form.tahun = data.thn
          this.form.createAt = data.createAt
          this.form.file_old =  data.file
      },
  
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
      // ====================================== PAGINATE ====================================
  
    },
  
    mounted () {
      var get_profile = JSON.parse(localStorage.profile);
              this.unitKerja = get_profile.profile.unit_kerja_id;
              this.unit_lppd = get_profile.profile.unit_lppd;
      this.getView();
      this.getTahun();
      this.getUnit();
    },
  }
  